import { gql } from '@apollo/client';

export const subscribeCleaningReportsFileExported = gql`
  subscription MySubscription($userId: ID!, $requestToken: String!) {
    subscribeCleaningReportsFileExported(
      userId: $userId
      requestToken: $requestToken
    ) {
      fileUrls
    }
  }
`;
